import React, { useState, useContext, createContext, useEffect } from "react";
import { SliderServices } from "../services/SliderServices";
import { useClientCity } from "./useClientCity";
import { useLanguage } from "./useLanguage";

// ** Utils Imports
const sliderContext = createContext();

export function ProviderSlider({ children }) {
  const slider = useProviderSlider();
  return (
    <sliderContext.Provider value={slider}>{children}</sliderContext.Provider>
  );
}

export const useSlider = () => {
  return useContext(sliderContext);
};

function useProviderSlider() {
  const { language } = useLanguage();
  const {clientCity} = useClientCity()
  // ** State
  const [sliderItems, setSliderItems] = useState({
    items: [],
    loading: true,
    error: false
  });

  const makeItemSlider = (itemObj) => {
    if(itemObj.city_id !== ''){
      itemObj.city_id = Number(itemObj.city_id);
    }else{
      itemObj.city_id = 0
    }
    return itemObj;
  }

  // Get Items
  const getSlider = () => {
    setSliderItems((prev) => ({ ...prev, loading: true }));
    SliderServices.getLast()
      .then((data) => {
        if (Array.isArray(data?.data?.data) && data?.data?.data?.length > 0) {
          const dataItems = [];
          data?.data?.data?.forEach(sliderItem => {
            dataItems.push(makeItemSlider(sliderItem))
          });
          setSliderItems((prev) => ({
            ...prev,
            items: [...dataItems],
            error: false
          }));
        }
      })
      .catch((error) => {
        setSliderItems((prev) => ({ ...prev, error: true }));
      })
      .finally(() => {
        setSliderItems((prev) => ({ ...prev, loading: false }));
      });
  };

  useEffect(() => {
    if (clientCity && Object.keys(clientCity).length > 0) {
      if (clientCity.id !== 0) {
        getSlider();
      }
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientCity,language]);

  // Return State
  return {
    sliderItems,
    getSlider
  };
}
